<template>
    <div class="filter" :class="{'filter-expend':expended}">
        {{expended?"":$t('Components.MaterialFilterBar.title')}}
        <ul class="filter-box">
            <li>
                <span>{{ $t('Components.MaterialFilterBar.filter.name') }}</span>
                <Input
                        class="selector"
                        v-model="filter.name"
                        size="small"
                        @on-change="i=>{this.refresh_throttle()}"
                        clearable
                        :placeholder="$t('Message.placeholder')"
                />
            </li>
            <li>
                <span>{{ $t('Components.MaterialFilterBar.filter.categoryId') }}</span>
                <ApiSelector
                    class="selector"
                    size="small"
                    api="category"
                    v-model="filter.categoryId"
                    :userId="userId"
                />
            </li>
            <li v-if="!completeOnly">
                <span>{{ $t('Components.MaterialFilterBar.filter.status') }}</span>
                <Select transfer clearable class="selector" v-model="filter.status" size="small" :placeholder="$t('Message.placeholderSelect')">
                    <Option
                        v-for="item in filterOptions.status"
                        :value="item.value"
                        :key="item.value"
                    >{{ localize(item.label) }}</Option>
                </Select>
            </li>
            <li v-if="!videoOnly&&!imageOnly">
                <span>{{ $t('Components.MaterialFilterBar.filter.type') }}</span>
                <Select
                    transfer
                    clearable
                    class="selector"
                    v-model="filter.categoryId"
                    size="small"
                    :placeholder="$t('Message.placeholderSelect')"
                >
                    <Option
                        v-for="item in filterOptions.type"
                        :value="item.value"
                        :key="item.value"
                    >{{ localize(item.label) }}</Option>
                </Select>
            </li>
            <li>
                <span>{{ $t('Components.MaterialFilterBar.filter.topicId') }}</span>
                <ApiSelector
                    class="selector"
                    size="small"
                    api="topic"
                    v-model="filter.topicId"
                    :userId="userId"
                />
            </li>
            <li v-if="!anyTime" class="date-picker">
                <span>{{ $t('Components.MaterialFilterBar.filter.timeRange.title') }}</span>
                <DatePicker
                    transfer
                    ref="datePicker"
                    :options="options"
                    :editable="false"
                    size="small"
                    type="daterange"
                    split-panels
                    @on-change="filter.timeRange=$event;filter.timeSelected=0"
                    :placeholder="$t('Components.MaterialFilterBar.filter.timeRange.placeholder')"
                    style="width: 200px"
                ></DatePicker>
            </li>
        </ul>
        <div
            v-if="hasMore||expended"
            @click="expended = !expended"
            class="more-btn"
        >{{expended?$t('Components.MaterialFilterBar.button.packUp'):$t('Components.MaterialFilterBar.button.unfold')}}</div>
    </div>
</template>
<script>
import api from "@/api/Api";
import extend from "extend";
import apimodel from "@/model/ApiModel";
import ApiSelector from "@/components/ApiSelector";
import helper from "@/assets/helper";
import throttle from "lodash.throttle";

let { Const } = apimodel;

export default {
    props: [
        "value",
        "videoOnly",
        "imageOnly",
        "completeOnly",
        "anyTime",
        "userId"
    ],
    components: {
        ApiSelector
    },
    mixins: [
        {
            methods: helper
        }
    ],
    data() {
        return {
            hasMore: false,
            expended: false,
            filterOptions: {
                category_loading: false,
                category_cache: [],
                category: [],
                /*
                    Object.entries的作用
                    const obj2 = { foo: 'bar', baz: 'abc' };
                    console.log(Object.entries(obj2));  // [['foo', 'bar'], ['baz', 'abc']]
                */
                status: Object.entries(Const.MaterialCms.Material.Status).map(i => ({
                    value: i[1],
                    label: Const.MaterialCms.Material.Status(i[1])
                })),
                type: Object.entries(Const.Material.Type).map(i => ({
                    value: i[1],
                    label: Const.Material.Type(i[1])
                })),
                topic_loading: false,
                topic: []
            },
            filter: extend(
                {
                    name: null,
                    categoryId: null,
                    status: this.completeOnly ? Const.MaterialCms.Material.Status.Done : null,
                    type: null,
                    topicId: null,
                    timeRange: [0, 0],
                    timeSelected: 0
                },
                this.value
            ),
            // 时间限制
            options: {
                disabledDate: date => {
                    //明天以后不能选择
                    if (date.valueOf() > Date.now() + 24 * 3600 * 1000)
                        return true;

                    let selected = this.filter.timeSelected;
                    if (!selected || !selected.getTime) return false;

                    //选择的范围是1个月
                    let range = 30 * 24 * 3600 * 1000;
                    if (
                        date.valueOf() > selected.getTime() + range ||
                        date.valueOf() < selected.getTime() - range
                    )
                        return true;
                    else return false;
                }
            }
        };
    },
    watch: {
        "filter.categoryId": "refresh",
        "filter.status": "refresh",
        "filter.type": "refresh",
        "filter.topicId": "refresh",
        "filter.timeRange": "refresh"
    },
    methods: {
        async refresh() {
            //使用extend，避免filter没有改变触发不了响应
            let param = extend(true, {}, this.filter);
            if (
                param.timeRange &&
                param.timeRange.length == 2 &&
                param.timeRange[0] &&
                param.timeRange[1]
            ) {
                param.startTime = new Date(
                    param.timeRange[0] + " 0:0:0"
                ).getTime();
                param.endTime = new Date(
                    param.timeRange[1] + " 23:59:59"
                ).getTime();
            } else {
                delete param.startTime;
                delete param.endTime;
            }
            this.$emit("input", param);
        },
        clear() {
            this.filter.name = null;
            this.filter.categoryId = null;
            this.filter.status = this.completeOnly ? Const.MaterialCms.Material.Status.Done : null;
            this.filter.type = null;
            this.filter.topicId = null;
            this.filter.timeRange = [0, 0];
            this.filter.timeSelected = 0;
        },
        resize() {
            this.hasMore = this.$el.clientWidth != this.$el.scrollWidth;
        }
    },
    mounted() {
        this.refresh_throttle = throttle(this.refresh, 1000);

        window.addEventListener("resize", this.resize);
        this.$nextTick(this.resize);

        //时间选择器点击时立即更新timerange
        this.$refs.datePicker &&
            this.$refs.datePicker.$refs.pickerPanel.$refs.leftYearTable.$on(
                "on-pick",
                date => {
                    this.filter.timeSelected = date;
                }
            );
        this.$refs.datePicker &&
            this.$refs.datePicker.$refs.pickerPanel.$refs.rightYearTable.$on(
                "on-pick",
                date => {
                    this.filter.timeSelected = date;
                }
            );
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resize);
    }
};
</script>
<style lang="less" scoped>
.more-btn {
    position: absolute;
    background: rgba(200, 200, 200, 0.9);
    height: 100%;
    color: black;
    border-radius: 5px;
    right: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    z-index: 10;
}
.filter {
    overflow: hidden;
    white-space: nowrap;
    position: relative;
}
.filter-expend {
    overflow: visible;
    white-space: normal;
    position: static;
    .filter-box li {
        margin: 5px 5px;
    }
    .more-btn {
        position: relative;
    }
}
</style>
